import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => (
  <header className="app-header navbar">
    <div className="container-fluid">
      <Link to="/" className="navbar-brand mr-5" />
    </div>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/component.js